import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
} from '@angular/core';
import { KpiResultRowModel } from '../kpi-result-row.model';

@Component({
    selector: 'app-kpi-results-table',
    templateUrl: './kpi-results-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class KpiResultsTableComponent {
    @Input() public rows: KpiResultRowModel[] = [];

    @Input() public shownResultIds: Record<string, boolean> = {};

    @Input() public showYear = true;

    @Input() public showDepartment = true;

    @Input() public showPeriod = false;

    @Input() public isTrend = false;

    @Output() public shownResultIdsChange = new EventEmitter<
        Record<string, boolean>
    >();

    @ContentChild('details') public detailsTemplate: TemplateRef<{
        row: KpiResultRowModel;
    }>;

    @ContentChild('actions') public actionsTemplate: TemplateRef<{
        row: KpiResultRowModel;
    }>;

    @ContentChild('rowActions') public rowActionsTemplate: TemplateRef<{
        row: KpiResultRowModel;
    }>;

    public trackByFn(index: number, item: KpiResultRowModel): string {
        return item.id;
    }

    public toggleResult(resultId: string): void {
        const next = {
            ...this.shownResultIds,
            [resultId]: !this.shownResultIds[resultId],
        };
        this.shownResultIds = next;
        this.shownResultIdsChange.emit(next);
    }

    public isExpanded(resultId: string): boolean {
        return !!this.shownResultIds[resultId];
    }
}
